/**
 * BenefitCards — expandable benefit cards.
 * Ports the AB8 `.bcard` pattern (click a card to reveal `.more` detail) using
 * React state instead of classList toggling.
 *
 *   <BenefitCards items={[{ icon, title, summary, more }]} accent="#e85d9a" />
 */
import { useState } from 'react';
import { Icon } from '../ui/Icon';

export default function BenefitCards({ items = [], accent = '#333' }) {
  const [open, setOpen] = useState(null);
  return (
    <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
      {items.map((b, i) => {
        const isOpen = open === i;
        return (
          <button
            key={i}
            onClick={() => setOpen(isOpen ? null : i)}
            style={{
              textAlign: 'left', cursor: 'pointer', border: `1px solid ${accent}22`,
              borderRadius: '1rem', padding: '1.25rem', background: 'rgba(255,255,255,.7)',
              backdropFilter: 'blur(6px)', transition: 'transform .2s, box-shadow .2s',
              boxShadow: isOpen ? `0 10px 30px ${accent}22` : '0 2px 10px rgba(0,0,0,.04)',
              transform: isOpen ? 'translateY(-2px)' : 'none',
            }}
          >
            {b.icon && (
              <div style={{ marginBottom: '.5rem', color: accent }}>
                {typeof b.icon === 'string'
                  ? <Icon name={b.icon} className="w-6 h-6" />
                  : b.icon}
              </div>
            )}
            <div style={{ fontWeight: 700, marginBottom: '.25rem', color: accent }}>{b.title}</div>
            {b.summary && <div style={{ fontSize: '.9rem', opacity: .8 }}>{b.summary}</div>}
            <div style={{
              maxHeight: isOpen ? 240 : 0, overflow: 'hidden',
              transition: 'max-height .3s ease', marginTop: isOpen ? '.6rem' : 0,
            }}>
              <div style={{ fontSize: '.88rem', lineHeight: 1.55, opacity: .9 }}>{b.more}</div>
            </div>
            <div style={{ fontSize: '.75rem', marginTop: '.5rem', color: accent, opacity: .7 }}>
              {isOpen ? '− Less' : '+ More'}
            </div>
          </button>
        );
      })}
    </div>
  );
}
